export default "__VITE_ASSET__Bf6xoqaL__"